export default "__VITE_ASSET__CqD4kYaw__"